export enum PositionType {
    AnalistaTeste = 1,
    Desenvolvedor = 2,
    GerenteProjeto = 3,
    WebDesign = 4,
    AnalistaInfraestrutura = 5,
    AnalistaSuporte = 6,
    ScrumMaster = 7,
    AnalistaDBASenior = 8,
    DBAJunior = 9,
    AdministradorBD = 10,
    AnalistaRede = 11,
    AnalistaNegocio = 12,
    LiderTecnico = 13,
    AnalistaBI = 14,
    GestorFraude = 15,
    GerenteRelacionamento = 16,
    AnalistaRequisitos = 17,
    ArquitetoSistemas = 18,
    AnalistaFuncional = 19,
    AnalistaGovernanca = 20,
    AnalistaAlmPleno = 21,
    PRODUCTOWNER = 22,
    AnalistaSistema = 23,
    AnalistaProducao = 24,
    SystemConfigurationManager = 25,
    LiderInfraestrutura = 26,
    AnalistaDadosPleno = 27,
    EspecialistaUX = 28,
    AnalistaBD = 29,
    AnalistaQualidade = 30,
    InsideSales = 31,
    ConsultorAzure = 32,
    Comercial = 33,
    AgileCoachSenior = 34,
    Head = 35,
    LiderMarketing = 36,
    DevOps = 37,
    LiderQA = 38,
    SegurancaInformacao = 39,
    CientistaDados = 40,
    AnalistaSEO = 41,
    Redatora = 42,
    AnalistaMarketingProduto = 44
}

//  Analista de teste
//  Desenvolvedor
//  Gerente de Projeto/PO
//  Web Design
//  Analista de Infraestrutura
//  Analista de Suporte
//  Scrum Master
//  Analista DBA Sênior
//  DBA Junior
//  Administrador de banco de dados (DBA)
//  Analista de Rede
//  Analista de Negócio
//  Líder Técnico/Tech Leader
//  Analista BI
//  Gestor de Fraude
//  Gerente de Relacionamento
//  Analista de Requisitos
//  Arquiteto de Sistemas
//  Analista Funcional
//  Analista de Governança
//  Analista Alm Pleno
//  PRODUCT OWNER
//  Analista de Sistema
//  Analista de Produção
//  System Configuration Manager
//  Líder de Infraestrutura
//  Analista de Dados Pleno
//  Especialista UX
//  Analista de Bancos de Dados
//  Analista de Qualidade
//  Inside Sales
//  Consultor Azure
//  Consultor Azure
//  Agile Coach Senior
//  Head
//  Lider de Marketing
//  DevOps
//  Lider QA
//  SegurancaInformacao
// Cientista de Dados



// WEBPACK FOOTER //
// ./src/app/shared/enums/PositionType.ts